export default __webpack_public_path__ + "static/media/monkey-11.e19316e9.png";